<script setup>
</script>
<template>
    <div class="scrollbar"></div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.scrollbar {
    height: 6px;
    border-radius: 0.7rem;
    background-color: var(--fill-accent-2-3);
    cursor: grab;
    .swiper-scrollbar-drag {
        height: 100%;
        border-radius: 0.7rem;
        background: var(--fill-accent-2-1);
    }
    :deep(.swiper-scrollbar-drag) {
        height: 100%;
        border-radius: 0.7rem;
        background: var(--fill-accent-2-1);
    }
}
</style>